import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type PayforIconProps = CommonSvgProps

const PayforIcon: React.FC<PayforIconProps> = React.forwardRef<SVGSVGElement, PayforIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 63 78" {...props} ref={ref} color="none">
      <path
        d="M37.875 6.96106H8.83333C7.02102 6.96106 5.28293 7.681 4.00144 8.9625C2.71994 10.244 2 11.9821 2 13.7944V68.4611C2 70.2734 2.71994 72.0115 4.00144 73.293C5.28293 74.5745 7.02102 75.2944 8.83333 75.2944H49.8333C51.6456 75.2944 53.3837 74.5745 54.6652 73.293C55.9467 72.0115 56.6667 70.2734 56.6667 68.4611V25.7527L37.875 6.96106Z"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1667 6.96106V27.4611H56.6667"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0001 44.5443H15.6667"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0001 58.2111H15.6667"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5001 30.8777H15.6667"
        stroke="#7BB835"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="44.8369" cy="18" r="16" fill="white" stroke="#51565C" strokeWidth="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9521 21.2814C50.9521 22.5218 50.5221 23.5745 49.6622 24.4397C48.8023 25.3049 47.5557 25.8294 45.9226 26.0131V28.5858H44.1449V26.0361C43.0754 25.9596 42.0637 25.7528 41.1098 25.4159C40.1559 25.079 39.3972 24.6503 38.8335 24.1296L39.8091 21.8097C40.3438 22.2691 40.9942 22.6557 41.7602 22.9697C42.5262 23.2836 43.3211 23.4788 44.1449 23.5554V18.9615C43.1187 18.7011 42.2624 18.414 41.5759 18.1001C40.8894 17.7862 40.3149 17.3268 39.8524 16.7219C39.3899 16.117 39.1587 15.3169 39.1587 14.3216C39.1587 13.0812 39.585 12.0246 40.4377 11.1518C41.2905 10.2789 42.5262 9.75828 44.1449 9.58984V6.99426H45.9226V9.5439C46.7319 9.58984 47.5232 9.73531 48.2964 9.98032C49.0696 10.2253 49.7453 10.5469 50.3234 10.945L49.4346 13.265C48.3362 12.5912 47.1655 12.1778 45.9226 12.0246V16.6645C46.9632 16.9248 47.8267 17.2081 48.5132 17.5144C49.1997 17.8206 49.7778 18.2762 50.2475 18.8811C50.7172 19.4859 50.9521 20.286 50.9521 21.2814ZM41.9554 14.1829C41.9554 14.6882 42.1432 15.094 42.519 15.4003C42.8948 15.7065 43.4368 15.9669 44.1449 16.1813V12.0927C43.4078 12.2152 42.8586 12.4602 42.4973 12.8277C42.136 13.1952 41.9554 13.6469 41.9554 14.1829ZM45.9225 23.509C46.6885 23.3865 47.2557 23.1491 47.6243 22.7969C47.9928 22.4447 48.1771 22.0083 48.1771 21.4877C48.1771 20.967 47.982 20.5497 47.5917 20.2358C47.2015 19.9219 46.6451 19.6577 45.9225 19.4434V23.509Z"
        fill="#53A2D9"
      />
    </Svg>
  )
)

PayforIcon.propTypes = commonPropTypes
PayforIcon.defaultProps = commonDefaultProps

export default PayforIcon
